import * as THREE from 'three';

/**
 * Checks if the given object is a THREE.Object3D instance.
 */
export const isObject3D = (object: unknown): object is THREE.Object3D => {
  return !!(object && (object as THREE.Object3D).isObject3D);
};
